// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"613":"295c3ff5","621":"3b4bcfbf","743":"66264c75"}[chunkId] + ".chunk.js";
};